/**
 * Which queues a staff screen shows as over their alert level.
 *
 * The server decides whether a queue is raised (internal/notify/watcher), so every
 * screen agrees and a screen opened mid-alert knows at once. This only picks which
 * of them a screen shows and names them: reception and the Floor show every one,
 * a counter only the queues its work profile calls from — the people who can do
 * something about that line. In the order the branch lists its queues, and only
 * queues still on the floor.
 */
import type { BranchState } from './branchState'
import { nameIn, type StaffLanguage } from './staffText'

export interface ShownAlert {
  queueId: string
  queue: string
  reason: 'waiting' | 'longest'
  since: string
  waiting: number
}

export function alertsToShow(state: BranchState, lang: StaffLanguage, onlyQueues?: readonly string[]): ShownAlert[] {
  const out: ShownAlert[] = []
  for (const q of state.queues) {
    if (onlyQueues && !onlyQueues.includes(q.queueId)) continue
    const alert = state.alerts.find((a) => a.queueId === q.queueId)
    if (!alert) continue
    out.push({ queueId: q.queueId, queue: nameIn(q.name, lang, q.code), reason: alert.reason, since: alert.since, waiting: q.waiting })
  }
  return out
}
